import { render } from "./JenisHakmilik.vue?vue&type=template&id=d844495c"
import script from "./JenisHakmilik.vue?vue&type=script&lang=js"
export * from "./JenisHakmilik.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__